<div>
  <div #certificateRef style="position: absolute; left: -9999px; top: 0">
    <span>Santosh Pal</span>
  </div>

  <button type="submit" class="btn btn-warning" (click)="downloadPDF()">
    <i class="bi bi-filetype-pdf"></i> Download as PDF
  </button>
</div>
